export default "__VITE_ASSET__e76e7740__"